<template>
  <div class="app-wrap">
    <template v-if="!!trans">
      <div class="registration">
        <div class="talk-logo"></div>
        <h1 class="header--mobile">
          <span class="header__text">{{ trans.mobileHeader1 }}</span>
        </h1>
        <div class="bottom-logos">
          <div class="bottom-logo iso2"></div>
          <div class="bottom-logo gdpr"></div>
          <div class="bottom-logo esomar"></div>
        </div>
      </div>
      <RegistrationBox :trans="trans" />
    </template>
  </div>
</template>

<script>
import RegistrationBox from '~/src/RegistrationBox';
import { IMAGE_ROOT, LANG_CODE } from '~/utils/constants';

export default {
  components: { RegistrationBox },
  data() {
    return {
      trans: null,
      IMAGE_ROOT,
      LANG_CODE
    };
  },
  props: {
    translations: Promise
  },
  mounted() {
    this.translations.then(t => {
      this.trans = t;
    });
  }
};
</script>
<style lang="less">
@import '../assets/registration.less';
</style>
